var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 16L3.5 5L9 10L12.5 4L16 10L21.5 5L19.5 16H5.5ZM19.5 19C19.5 19.6 19.1 20 18.5 20H6.5C5.9 20 5.5 19.6 5.5 19V18H19.5V19Z",
    fill: "#FFD600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiCrown);
export default __webpack_public_path__ + "static/media/mdi_crown.689263d1107178768ee8a53e34fa70f1.svg";
export { ForwardRef as ReactComponent };